export default {
  vidFleet_video_player_wakingCamera: 'Waking up camera...',
  vidFleet_video_player_stopingCamera: 'Finishing streaming...',
  vidFleet_video_player_stoppedCamera: 'Streaming finished',
  vidFleet_video_player_errorApi: 'The video could not be loaded, please try again',
  vidFleet_video_player_retryMessage: 'The video could not be loaded, either because the server or network failed, please try again.',
  vidFleet_video_player_cameraOffline: 'The camera is offline',
  vidFleet_video_player_360Message: 'Please use your mouse drag and drop the video',
  vidFleet_errorAccessDenied: 'The video could not be loaded, access denied',
  vidFleet_timeout: 'Live video has timed out.',
  vidFleet_clip_details: 'Clip Details',
}